import styled from "styled-components";
import iconCalendar from "../../assets/icons/icons8-calendário-16.png"
import { theme } from "../../styles/theme";

export const H3 = styled.h3`
    font-size: 18px;
    margin-bottom: 20px;
`;

export const Label = styled.label`
    padding-left: 15px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #8a92a2;
    margin-top: 20px;
`;

export const FilterArea = styled.div`
    width: 50%;
    display: flex;
    flex-direction: row;
    /* justify-content: flex-start; */
    align-items: flex-start;

    #labelcultura {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      letter-spacing: normal;
      z-index: 1;
      opacity: 1;
      position: absolute;
      color: #586377;
      margin-left: 23px;
      margin-top: 6px;
      background-color: #FFF;
    }

    #multiselectContainerReact{
      margin: 47px 0px 0px 0;

      .searchWrapper {
        border-radius:  25px !important;
        margin-top: -34px;
      }

      .searchBox{
        margin: 14px 0 0px 10px;
        background-color: #FFF;
      }

      span{
        background: #00b43f;
        width: auto;
      }

      background: white;
      max-width: 220px;
      border-radius: 25px;


    }
    @media only screen and (max-width: 1285px){
      flex-direction: column !important;
      width: 100%;
      .alvosPorCultura{
        min-height: 500px !important;
      }
      #multiselectContainerReact{
        width: 256px;
      }
      .culturasAlv {
        width: 285px !important;
        display: -webkit-box !important;
        display: -webkit-flex !important;
        display: -ms-flexbox !important;
        display: flex !important;
      }

      .eItXMf #multiselectContainerReact span {
        margin: 3px !important;
      }

      .searchBox {
        margin: 5px 0 6px 5px !important;
      }

      .optionListContainer{
        z-index: 3;
      }
    }
`;

export const SelectArea = styled.div`
    min-width: 80%;
    margin-left:10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-right: 10px;

    @media only screen and (max-width: 1285px){
      margin-left:0px;
      .dKWSnq{
        margin-top: 15% !important;
        margin-left: -28%;
        max-width: 269px;
      }
      .bPpYOh{
        margin-top: 15% !important;
        margin-left: -28%;
        max-width: 269px;
      }
    }
`;

export const ProdutosNome = styled.div`
  font-size: 15px;
  margin-top: 6px;
  margin-left: 15px;
`;

export const AreaTratada = styled.div`
    margin-top: 20px;
`;

export const IconeBotao = styled.div`
  position: relative;
  
    display: flex;
    justify-content: space-between;

    .pdf {
      position: relative;
    }

    .pdf #msgBaixarPdf {
      display: none;
    }

    .pdf:hover #msgBaixarPdf {
      display: flex;
      justify-content: center;
      position: absolute;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      text-align: center;
      align-items: center;
      color: #FFF;
      background-color: ${theme.colors.gray.Cinza_1};
      width: 80px;
      height: 18px;
      opacity: 0.9;
      border-radius: 5px;
      margin-top: -17px;
      margin-left: -33px;
      z-index: 10;
    }

    .pdf:hover #msgBaixarPdf::after {
      display: flex;
      position: absolute;
      background-color: ${theme.colors.gray.Cinza_1};
      width: 6px;
      height: 6px;
      top: 14px;
      margin-left: 0px;
      content: '';
      transform: rotate(45deg);
    }

    .xlsx {
      position: relative;
    }

    .xlsx #msgBaixar {
      display: none;
    }

    .xlsx:hover #msgBaixar {
      display: flex;
      justify-content: center;
      position: absolute;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      text-align: center;
      align-items: center;
      color: #FFF;
      background-color: ${theme.colors.gray.Cinza_1};
      width: 80px;
      height: 18px;
      opacity: 0.9;
      border-radius: 5px;
      margin-top: -42px;
      margin-left: -30px;
      z-index: 10;
    }

    .xlsx:hover #msgBaixar::after {
      display: flex;
      position: absolute;
      background-color: ${theme.colors.gray.Cinza_1};
      width: 6px;
      height: 6px;
      top: 14px;
      content: '';
      transform: rotate(45deg);
    }
`;

export const DataFilter = styled.div`
    width: 100%;
    height: auto;
    border-radius: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


    .input-data-filter{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .input-date{
            border: none;
            border-right: 1px;
            background-color: #f3f3f5;
            padding-right: 25px;
            height: 40px;
        }

        .input-date + .input-date{
            border-left: solid 1px #dfe4eb;
            padding-left: 25px;
            padding-right: 0px;
        }

        input[type="date"]::-webkit-calendar-picker-indicator{
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            background: url(${iconCalendar}) no-repeat;
            border-width: thin;
            margin-top: 5px;
        }

        input[type="date"]::-webkit-inner-spin-button{
            margin-top: 8px;
        }

    }

`;

export const ChartArea = styled.div`
    width: 100%;
    height: auto;
    min-height: 100px;
    margin-top: 10px;
    padding-left: 5px;
`;


export const InfoChart = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1050px) {
    margin-top: 24px;
  }

  @media only screen and (max-width: 640px) {
    width: 100%;
    flex-direction: row;
  }

`

export const ChartLineArea = styled.div`

  @media only screen and (max-width: 1050px) {
    height: auto;
    width: 80%;
    margin-top: 24px;
  }

  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`

export const ColumnTitle = styled.p`
    margin: 0 0 14px 0;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const DonutRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const DonutHole = styled.div`
    position: relative;
    z-index: 2;
    width: 76px;
    height: 76px;
    min-width: 76px;
`;

export const Legend = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const LegendItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${theme.colors.gray.Cinza_2};

    .dot {
        width: 8px;
        height: 8px;
        min-width: 8px;
        border-radius: 50%;
        margin-top: 3px;
        background-color: ${props => props.color};
    }

    .label {
        flex: 1;
        min-width: 0;
    }

    .percent {
        text-transform: none;
        font-weight: 700;
        color: ${theme.colors.green.Verde_AgroReceita};
    }
`;

